import React from "react";
import '../../view/frete/freight.css'

const BackButton = () => {
    return (
        <button type="primary" class="w-100 btn btn-primary btn-cadastrar"> Voltar </button>
    );
}

export default BackButton;